// A tactic card as shown, with the strength per army it has gained when Sun Tzu went under it ({ tacticBonus,
// tacticBonusBy: { source, image } }), like a wonder Homer added a happy face to. The card is copied, so the one in the
// game is left as it is.
const LeaderNames = require('../Constants/Names/LeaderNames');
const Leaders = require('../Constants/Leaders/Leaders');

const WithTacticBonus = (card, gameState) => {
    const bonus = card ? gameState?.tacticBonuses?.[card.id] ?? 0 : 0;
    if (!bonus)
    {
        return card;
    }
    return Object.assign(Object.create(Object.getPrototypeOf(card)), card, {
        tacticBonus: bonus,
        tacticBonusBy: { source: LeaderNames.SunTzu, image: Leaders[LeaderNames.SunTzu].image },
    });
};

module.exports = { WithTacticBonus };
